var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.093,
    height: 18,
    viewBox: "0 0 9.093 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_834_",
    transform: "translate(-76.703)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_835_",
    d: "M76.993,9.587h1.973V17.71a.29.29,0,0,0,.29.29H82.6a.29.29,0,0,0,.29-.29V9.625h2.268a.29.29,0,0,0,.288-.257l.344-2.99a.29.29,0,0,0-.288-.324H82.893V4.179c0-.565.3-.852.9-.852h1.708a.29.29,0,0,0,.29-.29V.292a.29.29,0,0,0-.29-.29H83.151c-.017,0-.053,0-.108,0a4.511,4.511,0,0,0-2.95,1.112,3.093,3.093,0,0,0-1.029,2.75V6.054H76.993a.29.29,0,0,0-.29.29V9.3A.29.29,0,0,0,76.993,9.587Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.b245bdbeefbd7a3051c74c91766806eb.svg";
export { ForwardRef as ReactComponent };